import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ReferralPageBannerService } from '../home/referral-page-banner/referral-page-banner.service';
import { OeAppPersonService } from './oe-app-person.service';
import { OeAppService } from './oe-app.service';
import { TranslationService } from './translation.service';
import { Language } from './types/language';
import { PlayerViewerType } from './types/player-viewer-type.enum';
import { UtilsService } from './utils.service';
import { Program } from './types/program-type';

@Injectable({
  providedIn: 'root',
})
export class LessonPlayerService {
  constructor(
    private readonly oeAppService: OeAppService,
    private readonly oeAppPersonService: OeAppPersonService,
    private readonly translationService: TranslationService,
    private readonly referralBannerService: ReferralPageBannerService
  ) {}


  getActivityUrl$(lessonId: string, viewerType: PlayerViewerType, isElligible: boolean, bookmark = 0, lessonType: Program['lessonType'] = 'MINI_LESSON', courseId?: number) {
    const language = this.translationService.getCurrentLanguage();

    const commonParams = {
      lessonId,
      language,
      bookmark,
      isTranslationButtonEnabled: this.isTranslationButtonEnabled(),
      showTranslationButton: this.showTranslationButton(),
      areSoundEffectsEnabled: true,
    };

    if (courseId) {
      commonParams['courseId'] = courseId;
    }

    const aiParams = {
      env: this.oeAppService.environment,
      personId: this.oeAppPersonService.id
    }

    const miniLessonParams = {
      environment: this.oeAppService.environment,
      viewerType,
      copilotEnabled: this.oeAppPersonService.copilotEnabled
    }

    const playerUrl = lessonType === 'AI' ? this.oeAppService.webLessonPlayerPageHost : this.oeAppService.activityPlayerHost();
    const urlParams = lessonType === 'AI' ? aiParams : miniLessonParams;
    const url = UtilsService.createUrl(playerUrl, {...commonParams, ...urlParams});
    
    if (!isElligible) {
      url.setParam('referralMessageElligible', isElligible);
    } else {
      return this.referralBannerService.localizedBonusAmount$.pipe(
        switchMap((referralBonusAmount) => {
          if (referralBonusAmount) {
            url.setParam('referralBonusAmount', referralBonusAmount);
            url.setParam('referralMessageElligible', isElligible);
          } else {
            url.setParam('referralMessageElligible', 'false');
          }
          return of(url.href);
        }),
        catchError(() => {
          url.setParam('referralMessageElligible', 'false');
          return of(url.href);
        })
      );
    }

    return of(url.href);
  }

  private isTranslationButtonEnabled(): boolean {
    return this.oeAppPersonService.preferredLang !== Language.ENGLISH;
  }

  private showTranslationButton(): boolean {
    return this.oeAppPersonService.levelNum < 2;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/lesson-player.service.ts